import { FindingDetails } from './component/findingDetailsWebComponent';
export { FindingDetails };
